import modalStyles from '../../styles/modal/Modal.module.css';

export const ModalOverlay = ({
	onClick,
	children
}: {
	onClick?: () => void;
	children?: React.ReactNode;
}) => {
	const closeModalOnClick = () => {
		if (onClick) {
			onClick();
		}
	};
	return (
		<section className={modalStyles.modalOverlay} id="modal-overlay" onClick={closeModalOnClick}>
			{children}
		</section>
	);
};
